const timeInMinutes = parseInt(document.querySelector(".countdown-popup__container").getAttribute("clock-start")) || 2.5;
const currentTime = Date.parse(new Date());
const deadline = new Date(currentTime + timeInMinutes * 60 * 1000);
const countdownClockEl = document.querySelector("#countdown-clock");
$(document).ready(() => {
  initializeClock("countdown-clock", deadline);
});

const getTimeRemaining = (endtime) => {
  const total = Date.parse(endtime) - Date.parse(new Date());
  const seconds = Math.floor((total / 1000) % 60);
  const minutes = Math.floor((total / 1000 / 60) % 60);
  return {
    total,
    minutes,
    seconds,
  };
};

const openModal = () => {
  const modalContainer = document.querySelector(".countdown-modal__container");
  if (modalContainer) modalContainer.classList.add("active");
};

const initializeClock = (id, endtime) => {
  const clock = document.querySelector(`#${id} span`);
  const timeinterval = setInterval(() => {
    const t = getTimeRemaining(endtime);
    clock.innerHTML = `${("0" + t.minutes).slice(-2)}:${("0" + t.seconds).slice(
      -2
    )}`;
    if (t.total <= 0) {
      openModal();
      clearInterval(timeinterval);
    }
  }, 1000);
};

const fmfAtcElements = document.querySelectorAll(".fmf-atc");
fmfAtcElements.forEach((el) => {
  el.addEventListener("click", () => {
    el.innerHTML = "GETTING YOUR OFFER READY";
    const productVid = parseInt(
      countdownClockEl.getAttribute("aria-product-vid")
    );
    const customTag = countdownClockEl.getAttribute("aria-custom-tag");
    let sellingPlanId;
    productVid === 45278482596098 || productVid == 45278482694402 || productVid == 45278481809666
      ? (sellingPlanId = 3039756546)
      : (sellingPlanId = 3010134274);
    let formData = {
      items: [
        {
          id: productVid,
          quantity: 1,
          selling_plan: sellingPlanId,
          form_type: "product",
          properties: {
            _custom_order_tag: customTag
          }
        }
      ]
    }
    if (productVid !== 45278481809666) formData.items[0].properties._move_to_S1B1 = "Move to S1B1";
    $.ajax({
      type: "POST",
      url: "/cart/add",
      dataType: "json",
      data: formData,
      success: async function (res) {
        window.location.href = `/discount/FIRSTMONTH?redirect=/checkout`;
        el.innerHTML = "Added";
      },
    }).fail(function (e) {
      return window.location.reload(), !1;
    });
  });
});
